/**
 * The admin tab bar — link mode, one tab per real URL.
 *
 * The EJS admin views share partials/admin-tabs.ejs and each view passes the tab it IS: `/admin/overview`,
 * `/admin/metrics`, `/admin/tests`, `/admin/jobs` (labelled Setup) and `/admin/storybook`. The URL is the tab
 * state, so every tab is deep-linkable, shows up as itself in the request metrics, and a reload keeps you
 * where you were. It is NOT client-side switching, and the SPA must not turn it into that.
 *
 * `id="admin-tabs"` is what the stylesheet and the browser suite address the bar by.
 */
import { Tabs } from '../../components/Tabs';

const ITEMS = [
  { key: 'overview', label: 'Overview', href: '/admin/overview' },
  { key: 'metrics', label: 'Metrics', href: '/admin/metrics' },
  { key: 'tests', label: 'Tests', href: '/admin/tests' },
  { key: 'jobs', label: 'Setup', href: '/admin/jobs' },
  { key: 'storybook', label: 'Storybook', href: '/admin/storybook' },
];

export function AdminTabs({ active }: { active: string }) {
  return (
    <Tabs
      id="admin-tabs"
      ariaLabel="Admin sections"
      variant="segmented"
      raised
      active={active}
      items={ITEMS}
      // No top margin: the bar is the first thing in `main`, which already sits below the header. The bottom
      // 16px is the EJS bar's own (`attrs: { style: 'margin: 0 0 16px' }`) — without it the panel under the
      // bar starts 16px high on every admin page.
      style={{ margin: '0 0 16px' }}
    />
  );
}
